import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import renderEnvComponent from 'data/common/renderEnvComponent';
import FormPushNotification from './Form/FormPushNotification';
import { addPushNotification, sendPushNotificationEvent } from '../../data/PushNotifications/actions';

class PushNotificationAdd extends PureComponent {
    render() {
        return <FormPushNotification type="add" sendDataFunc={addPushNotification} sendEventFunc={sendPushNotificationEvent} />;
    }
}

export default withRouter(renderEnvComponent('scenes/PushNotification/add', PushNotificationAdd));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/PushNotification/add.js